import React from "react";
import { motion } from "framer-motion";
import { GALLERY } from "../data/content";

export const Gallery = () => {
  return (
    <section id="projects" data-testid="projects-section" className="py-24 bg-secondary/30">
      <div className="px-6 md:px-12 lg:px-24">
        <div className="max-w-2xl mb-14">
          <span className="text-accent font-semibold text-sm uppercase tracking-wider">Recent work</span>
          <h2 className="mt-3 text-3xl md:text-4xl font-bold tracking-tight text-foreground">
            Spaces we've cleared & restored
          </h2>
          <p className="mt-4 text-muted-foreground text-lg">
            From cluttered basements to overgrown yards—see the difference a Prairie cleanout makes.
          </p>
        </div>

        <div className="grid grid-cols-2 lg:grid-cols-4 gap-4 auto-rows-[200px]">
          {GALLERY.map((src, i) => (
            <motion.div
              key={i}
              data-testid={`gallery-item-${i}`}
              initial={{ opacity: 0, scale: 0.96 }}
              whileInView={{ opacity: 1, scale: 1 }}
              viewport={{ once: true }}
              transition={{ duration: 0.5, delay: i * 0.08 }}
              className={`relative overflow-hidden rounded-sm group ${
                i === 0 ? "col-span-2 row-span-2" : ""
              }`}
            >
              <img
                src={src}
                alt={`Cleanout project ${i + 1}`}
                className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
              />
              <div className="absolute inset-0 bg-primary/0 group-hover:bg-primary/20 transition-colors" />
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};
